<nz-card class="round-border p-4" [nzLoading]="!loaded">
	<a [routerLink]="['/activity-log']">
		<nz-statistic
			[nzValue]="count | number"
			[nzTitle]="'activity-log_common_name' | translate"
		></nz-statistic>
	</a>
</nz-card>
